import { EventEmitter as NodeEventEmitter } from "events";
export class EventEmitter {
    constructor() {
        this.eventEmitter = new NodeEventEmitter().setMaxListeners(Infinity);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
        return {
            off: () => this.eventEmitter.removeListener(event, listener),
        };
    }
    once(event, listener) {
        this.eventEmitter.once(event, listener);
        return {
            off: () => this.eventEmitter.removeListener(event, listener),
        };
    }
    prependListener(event, listener) {
        this.eventEmitter.prependListener(event, listener);
        return {
            off: () => this.eventEmitter.removeListener(event, listener),
        };
    }
    emit(event, ...args) {
        this.eventEmitter.emit(event, ...args);
    }
}
